export const isPublicBlogEnabled = () =>
  process.env.NEXT_PUBLIC_AI_BLOG_ENABLED === 'true';
